module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-11.69129f7b.png";